import React, { JSXElementConstructor, PropsWithChildren } from 'react';

import { useFadeIn } from './hooks';
interface Props {
  direction: 'left' | 'right' | 'up' | 'down';
  translate?: number;
  delay?: number;
  transitionDuration?: number;
  wrapperTag?: JSXElementConstructor<any>;
  childTag?: JSXElementConstructor<any>;
  visible?: boolean;
  onComplete?: () => void;
}

export const FadeIn = (props: PropsWithChildren<Props>) => {
  const {
    direction,
    translate = 20,
    delay = 50,
    transitionDuration = 500,
    wrapperTag: WrapperTag = 'div',
    childTag: ChildTag = 'div',
    visible,
    onComplete,
    children,
  } = props;

  const maxIsVisible = useFadeIn({
    childrenCount: React.Children.count(children),
    visible,
    delay,
    transitionDuration,
    onComplete,
  });

  const move = {
    right: `translateX(-${translate}px)`,
    left: `translateX(${translate}px)`,
    up: `translateY(${translate}px)`,
    down: `translateY(-${translate}px)`,
  };

  return (
    <WrapperTag data-testid="fadein">
      {React.Children.map(children, (child, i) => (
        <ChildTag
          key={i} // Adicionei key para os filhos
          style={{
            transition: `opacity ${transitionDuration}ms, transform ${transitionDuration}ms`,
            transform: maxIsVisible > i ? 'none' : move[direction],
            opacity: maxIsVisible > i ? 1 : 0,
          }}
        >
          {child}
        </ChildTag>
      ))}
    </WrapperTag>
  );
};
